import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';
import { ConversationItem } from '../types/Conversation/Conversation';

export const useUpdateConversationTitle = () => {
    const chatService = new ChatService();
    return useMutation({
        mutationFn: ({ data, newTitle }: { data: ConversationItem; newTitle: string }) =>
            chatService.patchConversationTitle(data.conversationId, newTitle, data),
    });
};
